import {
	requests
}from "../../../../api/agent"

export default {
	getList       : (params) => requests.getWithParams('/RePossibleCharacteristics/GetList', params),
	getPagedAll   : (params) => requests.post('/RePossibleCharacteristics/GetPagedAll', params),
	getPaged      : (params) => requests.post('/RePossibleCharacteristics/GetPaged', params),
	getPagedAudit : (params) => requests.getWithParams('/RePossibleCharacteristics/GetPagedAudit', params),
	create        : (params) => requests.post('/RePossibleCharacteristics/Create', params),
	update        : (params) => requests.post('/RePossibleCharacteristics/Update', params),
	delete        : (params) => requests.post('/RePossibleCharacteristics/Delete', params),
	restore       : (params) => requests.post('/RePossibleCharacteristics/Restore', params)
}
